import styled from '@emotion/styled';
import { useFormikContext } from 'formik';
import { maxBy } from 'lodash';
import { partial } from 'ramda';
import React from 'react';
import { Button } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import SubmitButton from 'Shared/form/SubmitButton';
import toast from 'Shared/toast';
import { noGroupOption } from '../constants';
import createQuestionId from '../utils/createQuestionId';

const ToolbarStyle = styled.div`
    display: flex;
    align-items: center;
    margin-top: 1.25rem;
    margin-bottom: 0.625rem;

    button {
        margin-left: 7px;
    }
`;

const AssessmentManagerQuestionsToolbar = () => {
    const { values, setFieldValue, validateForm } = useFormikContext();
    const { parentQuestionId, parentAnswerId } = useParams();

    const addNewQuestion = partial((questionType) => {
        const newId = createQuestionId();
        const relevantQuestions = Object.values(values.questions).filter((q) => {
            return !q.group.id && ((!parentAnswerId && !q.parent_answer_id) || q.parent_answer_id === parentAnswerId);
        });
        const newPosition = (maxBy(relevantQuestions, 'attributes.position')?.attributes.position || 0) + 1;
        const parentQuestion = values.questions[parentQuestionId];
        const newQuestion = {
            question_id: newId,
            type: questionType,
            attributes: { position: newPosition },
            answers: [],
            group: noGroupOption,
            can_delete: true,
            parent_question_id: parentQuestion?.official_question_id || parentQuestion?.question_id,
            parent_answer_id: parentAnswerId,
        };
        setFieldValue(`questions.${newId}`, newQuestion);

        if (parentQuestionId && !parentQuestion.children?.[parentAnswerId]) {
            setFieldValue(`questions.${parentQuestionId}.children.${parentAnswerId}`, {});
        }
    });

    return (
        <ToolbarStyle>
            <div>Question Type: </div>

            <Button variant="outline-secondary" size="sm" onClick={addNewQuestion(['radio'])}>
                Radio
            </Button>
            <Button variant="outline-secondary" size="sm" onClick={addNewQuestion(['select'])}>
                Select
            </Button>
            <Button variant="outline-secondary" size="sm" onClick={addNewQuestion(['checkbox'])}>
                Checkbox
            </Button>
            <Button variant="outline-secondary" size="sm" onClick={addNewQuestion(['multiselect'])}>
                Multiselect
            </Button>
            <Button variant="outline-secondary" size="sm" onClick={addNewQuestion(['date'])}>
                Date
            </Button>
            <Button variant="outline-secondary" size="sm" onClick={addNewQuestion(['number'])}>
                Number
            </Button>
            <Button variant="outline-secondary" size="sm" onClick={addNewQuestion(['textbox'])}>
                Textbox
            </Button>
            <Button variant="outline-secondary" size="sm" onClick={addNewQuestion(['textarea'])}>
                Textarea
            </Button>
            <Button variant="outline-secondary" size="sm" onClick={addNewQuestion(['message'])}>
                Message
            </Button>

            <SubmitButton
                size="sm"
                ignoreDirty
                ignoreValid
                onClick={async () => {
                    const errors = await validateForm();
                    if (Object.keys(errors).length > 0) {
                        toast.error('There were errors validating your questions.');
                    }
                }}
            >
                Save
            </SubmitButton>
        </ToolbarStyle>
    );
};

export default AssessmentManagerQuestionsToolbar;
